import { render, staticRenderFns } from "./GraficosGeneralIndex.vue?vue&type=template&id=e16578f8"
import script from "./GraficosGeneralIndex.vue?vue&type=script&lang=js"
export * from "./GraficosGeneralIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports